module.exports = __webpack_public_path__ + "img/meeting_title1.532901a0.png";